<div id="generate-course-form-start" class="text-center animate__animated animate__fadeInRight animate__fast">
    <h1>Configuración inicial del curso</h1>

    <div class="container">
        <div id="new-course-name">
            <h2>Título</h2>
            <p>¿Qué título le va a dar a su curso?</p>
            <div class="form-group row">
                <input type="text" class="form-control" id="generate-course-name" name="generate-course-name" [(ngModel)]="courseFormName" required>
            </div>   
        </div>

        <!--
        <hr>
        
        <div class="d-none">
            <h2>Configuración</h2>
            <h6>Número de palabras por enunciado</h6>
            <div class="form-group row">
                <input type="number" class="form-control" id="generate-course-heading-words" name="generate-course-heading-words" [(ngModel)]="headingWords" min="100" required>
            </div>
        </div>
        -->

        <hr>

        <div id="new-course-category">
            <h2>Categoría</h2>
            <div class="form-group row">
                <select name="generate-course-category" id="generate-course-category" class="form-control" [(ngModel)]="courseFormCategory">
                    <option disabled selected value="0">Seleccione una categoría...</option>
                    <option *ngFor="let category of categories" [value]="category.id">
                        {{ category.name }}
                    </option>
                </select>
            </div>
        </div>

    </div>

    <button class="course-form-button" data-direction="forward" data-parent="start" data-next="source" (click)="move($event)">Continuar</button>
</div>